import { getNeighbors } from '../data/gridHelpers';
import { cellKey, isStartOrEnd, reconstructPath, emptyResult, pos } from './common';

export const bfs = (grid, startNode, endNode, rows, cols) => {
  if (startNode.row === endNode.row && startNode.col === endNode.col) {
    return { visitedNodesInOrder: [], path: [pos(startNode)] };
  }

  const visitedNodesInOrder = [];
  const queue = [grid[startNode.row][startNode.col]];
  const previous = {};
  const visited = new Set([cellKey(startNode.row, startNode.col)]);
  let head = 0;

  while (head < queue.length) {
    const current = queue[head++];

    if (!isStartOrEnd(current)) {
      visitedNodesInOrder.push(pos(current));
    }

    if (current.row === endNode.row && current.col === endNode.col) {
      return {
        visitedNodesInOrder,
        path: reconstructPath(previous, startNode, endNode),
      };
    }

    for (const neighbor of getNeighbors(current, grid, rows, cols)) {
      const nk = cellKey(neighbor.row, neighbor.col);
      if (!visited.has(nk)) {
        visited.add(nk);
        previous[nk] = current;
        queue.push(neighbor);
      }
    }
  }

  return emptyResult(visitedNodesInOrder);
};
